var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFolderIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 22,
    viewBox: "0 0 27 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.66667 21.6673C1.93333 21.6673 1.30556 21.4062 0.783333 20.884C0.261111 20.3618 0 19.734 0 19.0007V3.00065C0 2.26732 0.261111 1.63954 0.783333 1.11732C1.30556 0.595095 1.93333 0.333984 2.66667 0.333984H10.6667L13.3333 3.00065H24C24.7333 3.00065 25.3611 3.26176 25.8833 3.78398C26.4056 4.30621 26.6667 4.93398 26.6667 5.66732V19.0007C26.6667 19.734 26.4056 20.3618 25.8833 20.884C25.3611 21.4062 24.7333 21.6673 24 21.6673H2.66667ZM2.66667 19.0007H24V5.66732H12.2333L9.56667 3.00065H2.66667V19.0007Z",
    fill: "#40599B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFolderIcon);
export default __webpack_public_path__ + "static/media/folder-icon.d425efeb95dddcd99947604961b69ea3.svg";
export { ForwardRef as ReactComponent };